import { PIX_TYPES, PIX_TYPES_VALUES_MAX_LENGTH } from 'src/common/constants';

export const getInputMode = pixType => {
  switch (pixType) {
    case PIX_TYPES.PHONE:
      return {
        inputMode: 'tel',
        type: 'tel',
      };
    case PIX_TYPES.EMAIL:
      return {
        inputMode: 'email',
        type: 'email',
      };
    default:
      return {
        inputMode: 'text',
        type: 'text',
      };
  }
};

export const validateEmail = email =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

export const validatePixKey = (pixType, value) => {
  if (!value) return { message: 'required' };

  const errorMaxLength = ruleOption => ({ message: 'max_length', params: { ruleOption } });

  switch (pixType) {
    case PIX_TYPES.PHONE:
      if (value.length > PIX_TYPES_VALUES_MAX_LENGTH.PHONE)
        return errorMaxLength(PIX_TYPES_VALUES_MAX_LENGTH.PHONE);
      break;
    case PIX_TYPES.EMAIL:
      if (!validateEmail(value)) return { message: 'incorrect_email' };
      if (value.length > PIX_TYPES_VALUES_MAX_LENGTH.EMAIL)
        return errorMaxLength(PIX_TYPES_VALUES_MAX_LENGTH.EMAIL);
      break;
    case PIX_TYPES.EVP:
      if (value.length > PIX_TYPES_VALUES_MAX_LENGTH.EVP)
        return errorMaxLength(PIX_TYPES_VALUES_MAX_LENGTH.EVP);
      break;
    default:
      return null;
  }
};
